"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Icon"));



//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/index.ts
// module id = 304
// module chunks = 0